export const RULE_CATEGORIES = ['Finance', 'Security', 'Housekeeping'] as const;
export const RULE_SEVERITIES = [
  'Critical',
  'High',
  'Medium',
  'Low',
  'Unknown',
  'Info',
] as const;

export interface RulesStatistics {
  status: string;
  finance: number;
  security: number;
  housekeeping: number;
}

export interface PassedRulesStatistics {
  category: string;
  percentage: number;
}

export interface SeverityCount {
  rulesCount: number;
  resourcesCount: number;
}

export interface RulesCompliance {
  rulesCount: number;
  compliantRulesCount: number;
  resourcesCountBySeverity: Record<string, SeverityCount>;
}
